import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigApiServiceProvider } from '../../providers/config-api-service/config-api-service';
import { ConfigureServiceProvider } from '../configure-service/configure-service';
import { CommunicationServiceProvider } from '../communication-service/communication-service';
import { EncrDecrServiceProvider } from '../encr-decr-service/encr-decr-service';
import { DriveServiceProvider } from '../drive-service/drive-service';
import { LoadingController, ToastController } from 'ionic-angular';

const OBJLEN = 0;
const NO_INDEX = -1;
@Injectable()
export class NotifyServiceProvider {

  dataIndex = 0;
  subFolderLen = 0;
  objCurrentFolder: any = {};
  subFolderCont = {};
  incLen = 1;
  Def_splitParam = {
    "module_ID": {
      "condition1": {
        "filterType": "text",
        "type": "equals",
        "filter": "BGCFCGFHGE",
        "operator": "SPLIT"
      }
    }
  }
  countFlag = '';
  ShareID: any;
  mailShareID:any;
  shareInfo:any;
  acceessType:any='public';
  mailDataLink:any;
  shareFolder:any;
  loginUserName:any;
  folderFilterData: any = [];
  currentFolderTemplate: any = [];
  shareIdx = 0;
  mailIdx: any;

  constructor(public EncrDecrService: EncrDecrServiceProvider, public configureService: ConfigureServiceProvider, public toastController: ToastController, public driveService: DriveServiceProvider, public configApiService: ConfigApiServiceProvider, public communicationServ: CommunicationServiceProvider,public loadingController: LoadingController,) {
  }


  getSubFolderFilterParams(flag,folderTemp) {
    this.currentFolderTemplate =folderTemp; 
    this.countFlag = flag;
    this.objCurrentFolder = this.driveService.objCurrentFolder;
    this.subFolderLen = this.objCurrentFolder.folders.length;
    this.startPullCount();
  }

  startPullCount() {
    let filterPara = {};
    if (this.subFolderLen > this.dataIndex) {
      this.Def_splitParam['module_ID']['condition1']['filter'] = this.currentFolderTemplate['id'];
      this.subFolderCont = this.objCurrentFolder['folders'][this.dataIndex];
      let pullParams = this.subFolderCont['template'][OBJLEN].filterParams;
      filterPara = Object.assign({}, pullParams, this.Def_splitParam);
      let filterData = this.constructParams(filterPara);
      this.configApiService.driveApi.pullRecordCount.params['filterData'] = filterData
      this.configApiService.pullRequest(this.configApiService.driveApi.pullRecordCount.params, this.getFileDataCount)
    } else {
      console.log('data', this.folderFilterData);
      this.subFolderLen = 0;
      this.dataIndex = 0;
      if(this.countFlag  == 'After'){
        this.sendMail();
      }
    }
  }

  getFileDataCount = ((resp) => {
    this.updateCounts(resp);
    this.dataIndex = this.dataIndex + this.incLen;
    this.startPullCount();
  });

  updateCounts(resp) {
    if (this.countFlag == 'before') {
      this.folderFilterData.push({
        "folderId": this.subFolderCont['folder_id'],
        "folderName": this.subFolderCont['name'],
        'b_upload': resp[OBJLEN]['recordCount'],
        'A_upload': ''
      })
    } else {
      let folderIdx = this.folderFilterData.findIndex(folderProp => folderProp.folderId == this.subFolderCont['folder_id']);
      if (folderIdx != NO_INDEX) {
        this.folderFilterData[folderIdx]['A_upload'] = resp[OBJLEN]['recordCount'];
      }
    }
  }

  sendMail() {
    if(this.folderFilterData.length > this.shareIdx){
      let folder =  this.folderFilterData[this.shareIdx];
      if (folder.b_upload < folder.A_upload) {
        let folderIdx = this.objCurrentFolder['folders'].findIndex(folders => folders.folder_id == folder.folderId);
        if (folderIdx != NO_INDEX) {
          let objFolderData = this.objCurrentFolder['folders'][folderIdx];
          if(objFolderData['mailParams'] != undefined){
            this.pushShareCopy(objFolderData)
          }
        }
      }
      else{
        this.shareIdx = this.shareIdx + this.incLen;
        this.sendMail();
      }
    } else {
      this.notiftyToaster();
    }
  }


  pushShareCopy(objFolderData) {
    this.shareFolder = objFolderData;
    this.shareInfo = {
      'sharedFolder': objFolderData,
      'accessType': 'public',
      'pullFolderTemplate': {
        "client": this.configureService.getStudio(),
        'userid': this.configureService.getLoginUserID(),
        'app_code': this.configApiService.currentDriveApp['app_code']
      }
    }
    let shareFolder = JSON.parse(JSON.stringify(this.shareInfo))
    shareFolder['sharedFolder']['IsReadOnlyShare'] = 'YES';
    shareFolder['sharedFolder']['author'] = this.configureService.getLoginData();
    this.driveService.shareInfoFolder(shareFolder['sharedFolder'], shareFolder, (_respData) => {
     this.shareInfo.ShareID = _respData;
      this.mailShareID = _respData;
      this.pushShareUser();
    });
  }

  pushShareUser() {
    let pushParams = {
      "SharedInfo": this.shareInfo,
      "ShareType": "Folder",
      "TemplateID": this.currentFolderTemplate['id'],
      "ReceiverEmail": "",
      "TemplateName": this.currentFolderTemplate['templateName'],
      "AccessType": this.acceessType,
      "UserFolder": this.objCurrentFolder['folder_id'],
      "userid": this.configureService.getLoginUserID(),
      "ShareID": this.shareInfo.ShareID != undefined ? this.shareInfo.ShareID : ''
    }
    let pushObjData = Object.assign({}, this.configApiService.driveApi.pushLinkShareUser.params, pushParams);
    this.configApiService.pushRequest(pushObjData, this.linkGenerateCbck);
  }


  linkGenerateCbck = (responsedata => {
    if (this.shareFolder.hasOwnProperty('IsReadOnlyShare')) {
      delete this.shareFolder.objCurrentFolder['IsReadOnlyShare'];
    }
    this.mailDataLink = this.generateLinkUrl(responsedata["ShareID"]);
    this.MailPush();
  });

  generateLinkUrl(shareId) {
    this.ShareID = shareId;
    let urlParams = shareId + '&studio=' + this.configureService.getStudio() + '&userid=' + this.configureService.getLoginUserID();
    let encUrlParams = this.EncrDecrService.encrypt('DRIVESYNC123##', urlParams);
    let generateUrl: any = '';
    if (window.location.search) {
      generateUrl = window.location.origin + window.location.pathname + window.location.search + '&ShareID=' + encUrlParams;
    } else {
      generateUrl = window.location.origin + window.location.pathname + '/?ShareID=' + encUrlParams;
    }
    return generateUrl
  }

  MailPush(){
    if(this.shareFolder['mailParams']['Email_id'].length > 1){
      this.shareFolder['mailParams']['Email_id'].forEach((email_id, idx) => {
        this.mailIdx = idx;
        this.sendMailPush(email_id);
      })
    }else if(this.shareFolder['mailParams']['Email_id'].length == 1){
      this.sendMailPush(this.shareFolder['mailParams']['Email_id'][OBJLEN])
    }
  }

  sendMailPush(Email_id){
    this.loginUserName = this.configureService.getLoginData()["user"];
    let mailBody = this.convertHtml(this.shareFolder['mailParams']['Message'], this.mailDataLink);
    let mailScheduler = { 'TOID': Email_id, 'CC': '', 'BCC': '', 'FROMID': this.loginUserName, 'BODY': mailBody, 'ShareID': this.ShareID, 'SUBJECT': this.shareFolder['mailParams']['Subject'] };
    let objPushParams = Object.assign({}, this.configApiService.driveApi.pushMailShareUser.params,mailScheduler);
    this.configApiService.pushRequest(objPushParams, this.mailSentResponseStatus);
  }

  mailSentResponseStatus = ((responsedata) => {
    if(responsedata === 'SUCCESS') {
      if (this.mailShareID) {
        delete this.mailShareID;
        this.shareIdx = this.shareIdx + this.incLen;
        this.sendMail();
      }
    }
  })

  notiftyToaster() {
    const toast = this.toastController.create({
      message: 'User Notification Sent Successfully !!.',
      duration: this.configApiService.toastDuration
    });
    toast.present();
    this.folderFilterData = [];
    this.shareIdx = 0;
  }

  convertHtml(text, link) {
    let bodyHtml: any = '';
    bodyHtml += '<div  style="width: 35%;"><table border="0" cellpadding="0" cellspacing="0" style="width: 100%;">' +
      '<thead border="0" cellpadding="0" cellspacing="0" width="78%"><tr><td>';
    if (text) {
      bodyHtml += '<div style="margin: 12px;">' + text.replace(/\r\n|\r|\n/g, "</p><br /><p>") + '</div>';
    }
    bodyHtml += '</td></tr></thead><tbody style="padding: 12px;margin: 1px; background-color: #e6e6e694;" border="0" cellpadding="0" cellspacing="0">' +
      '<tr border="0" cellpadding="0" cellspacing="0"><td border="0" cellpadding="0" cellspacing="0">' +
      '<div style="margin: 12px;display: flex;"><div style="margin-left: 20px;"><img src="https://upload.wikimedia.org/wikipedia/commons/thumb/a/a7/Google_Docs_logo.svg/740px-Google_Docs_logo.svg.png" style="width: 46px;">' +
      '</div><div style="margin-top: 25px;margin-left: 16px;"><span style="font-weight:bold">' + this.shareFolder.name+ '</span></div></div>' +
      '</td></tr><tr border="0" cellpadding="0" cellspacing="0"><td border="0" cellpadding="0" cellspacing="0"><div style="margin: 12px;">' +
      "<a href='" + link + "' style='color: #fff;background-color: #467fff;padding:6px 21px;border: 1px solid;border-radius: 3px;font-size: 16px;margin-left: 8px;cursor: pointer;text-decoration:none'>open</a>" +
      '</div></td></tr></tbody><tfoot style="margin:1px;background-color: #cccccc;"><tr><td></td>' +
      '</tr></tfoot></table></div><br>' +
      '<div style="height: 50px;"><span style="margin-top:10px">Regards,<br><span> ' + this.loginUserName + '</span></span></div>';
    return bodyHtml;
  }
 

  private constructParams(params): any {
    if (Object.keys(params).length) {
      return JSON.stringify(params);
    }
  }

  ngAfterViewInit() {
    this.folderFilterData = [];
    this.shareIdx = 0;
  }

}



// WEBPACK FOOTER //
// ./src/providers/notify-service/notify-service.ts